module.exports = __webpack_public_path__ + "static/media/group_photo.98e71ca8.jpg";